import { SpaceWithFullWidth } from "@/sharedStyled";
import { faCircleInfo } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Input, Space, Typography } from "antd";
import { bool, func, string } from "prop-types";
import { useIntl } from "react-intl";

const DetailsCard = ({ setModel, name, description, loading }) => {
  const intl = useIntl();

  return (
    <Card
      title={
        <Space>
          <FontAwesomeIcon icon={faCircleInfo} />
          {intl.formatMessage({ id: "layout.detailsCardTitle" })}
        </Space>
      }
      loading={loading}
    >
      <SpaceWithFullWidth direction="vertical" size="middle">
        <SpaceWithFullWidth direction="vertical" size="small">
          <Typography.Text>
            {intl.formatMessage({ id: "layout.nameInputLabel" })}
          </Typography.Text>
          <Input
            value={name}
            onChange={({ target }) => setModel({ name: target.value })}
            data-test-id={`details-card-name-input`}
          />
        </SpaceWithFullWidth>
        <SpaceWithFullWidth direction="vertical" size="small">
          <Typography.Text>
            {intl.formatMessage({ id: "layout.descriptionInputLabel" })}
          </Typography.Text>
          <Input
            value={description}
            onChange={(event) => setModel({ description: event.target.value })}
            data-test-id={`details-card-description-input`}
          />
        </SpaceWithFullWidth>
      </SpaceWithFullWidth>
    </Card>
  );
};

DetailsCard.propTypes = {
  setModel: func.isRequired,
  name: string,
  description: string,
  loading: bool,
};

export default DetailsCard;
